<template>
  <img :class="color" :src="srcUrl" :alt="alt" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import { FORM_ICONS } from '../../../icons'

export default {
  name: 'TkIcon',
  props: {
    name: {
      required: true,
      type: String,
      validator: function (value) {
        return FORM_ICONS.icons.indexOf(value) !== -1
      },
    },
    color: {
      type: String,
      default: undefined, // 今のところデフォルトの他は 'white', 'red', 'blue', 'black' が指定できる
    },
  },
  computed: {
    srcUrl() {
      return FORM_ICONS.urlResolver(this.name)
    },
    alt() {
      return FORM_ICONS.alts[this.name] || ''
    },
  },
}
</script>

<style scoped lang="scss">
// 最初にbrightness(0) で黒にすることで、元の色の影響を受けず色を変えられる
.white {
  filter: brightness(0) invert(1);
}

.red {
  filter: brightness(0) invert(56%) sepia(86%) saturate(5172%) hue-rotate(337deg) brightness(96%) contrast(103%);
}

.blue {
  filter: brightness(0) invert(34%) sepia(97%) saturate(551%) hue-rotate(171deg) brightness(89%) contrast(94%);
}

.gray {
  filter: brightness(0) invert(1) brightness(0.5);
}

.black {
  filter: brightness(0);
}
</style>
